import React, { forwardRef, useEffect } from "react";
import "./Styles.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Image1 from "../assets/gif6.gif";
import Image2 from "../assets/memory companion.gif";

const HowItWorks = forwardRef((props, ref) => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="memory-section" ref={ref}>
      <div className="container">
        
        {/* --------- FIRST SECTION --------- */}
        <div className="row align-items-center">
          {/* Image Left */}
          <div className="col-lg-5" data-aos="fade-right">
            <div className="memory-image" style={{marginRight:"30%"}}>
              <img
                src={Image1}
                alt="24/7 Calling"
                className="img-fluid"
                loading="lazy"
              />
            </div>
          </div>

          {/* Text Right */}
          <div className="col-lg-7" data-aos="fade-left" data-aos-delay="200">
            <div className="memory-item" style={{marginRight:"8%"}}>
              <h3 className="memory-title">
                24*7 <span style={{ color: "#ff007f" }}>Calling</span>
              </h3>
              <p >
                gupsy breaks barriers by talking to you in the language you're
                most comfortable with. Whether it's Hindi, English, Spanish, or
                more — your companion adapts to your voice and words, making every
                interaction feel natural.
              </p>
            </div>
          </div>
        </div>

        {/* --------- SECOND SECTION --------- */}
        <div className="row align-items-center flex-lg-row-reverse">
          {/* Image Right */}
          <div className="col-lg-5" data-aos="fade-left" data-aos-delay="400">
            <div className="memory-image" style={{marginLeft:"30%"}}>
              <img
                src={Image2}
                alt="Remembers Memory"
                className="img-fluid"
                loading="lazy"
              />
            </div>
          </div>

          {/* Text Left */}
          <div className="col-lg-7" data-aos="fade-right" data-aos-delay="600">
            <div className="memory-item" style={{marginLeft:"12%"}}>
              <h3 className="memory-title">
                Remembers Memory — Your stories remembered,{" "}
                <span style={{ color: "#ff6f61" }}>not forgotten</span>
              </h3>
              <p>
                gupsy lets you design a companion that feels truly yours. From
                personality traits to communication style, you decide how your AI
                should behave — caring, witty, supportive, or even your late-night
                3 AM friend.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
});

export default HowItWorks;
